import { LocationCardValue } from '../interfaces';

/**
 * Respuesta que se envía al CMS para una pregunta de tipo `country`.
 *
 * El control lo alimentan dos componentes —el grid de banderas y el
 * autocompletado de Google Places—, y ambos dejan en el formulario un
 * `LocationCardValue` con `countryCode` en ISO-2 (`ES`, `PT`…), que es
 * justo el `iata` que el CMS guarda y con el que filtra.
 *
 * Antes se enviaba el objeto entero sin `countryCode`, es decir
 * `{ address, lat, long }`: el CMS no lee ninguna de esas claves y el
 * filtro de país del panel de estadísticas reventaba al tratar la
 * respuesta como texto (HRS-3108).
 */
export function toCountryAnswer(value: unknown): unknown {
  if (typeof value !== 'object' || value === null) return value;

  const { countryCode, address } = value as LocationCardValue;

  return countryCode?.toUpperCase() || address || '';
}
